import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyD7Eu8b2QjHjUdLxB5twffOsGN_jeh8c9w",
  authDomain: "spatialoracles-8b65a.firebaseapp.com",
  projectId: "spatialoracles-8b65a",
  storageBucket: "spatialoracles-8b65a.appspot.com",
  messagingSenderId: "223767743721",
  appId: "1:223767743721:web:1a753b832f0ae96da8f478"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);